import axios from 'axios';
import config from '../config';

const formatHmdState = (state) => {
  const {
    display,
    action,
    line1Text = '',
    line2Text = '',
    line3Text = '',
    properties = {},
    lastState = null,
  } = state || {};
  return {
    display,
    action,
    line1Text,
    line2Text,
    line3Text,
    properties,
    lastState,
  };
};

export const getHmdState = async (thingName) => {
  const { hmdUrl } = config || {};
  return axios({
    method: 'GET',
    url: hmdUrl,
    params: {
      thingName,
    },
    validateStatus: () => true, // do not throw errors on status >= 400
  }).then((resp) => {
    const { data } = resp || {};
    const { desired_hmd_state: desired, reported_hmd_state: reported } = data || {};
    return { desired: formatHmdState(desired), reported: formatHmdState(reported) };
  });
};

export const updateHmdState = async (thingName, data) => {
  const { hmdUrl } = config || {};
  return axios({
    method: 'POST',
    url: hmdUrl,
    params: {
      thingName,
    },
    data: {
      ...data,
      properties: {
        ...data.properties,
        clientOrigin: 'HIPPO',
      },
    },
  }).then((resp) => resp.data);
};

export default { getHmdState, updateHmdState };
